import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { toast } from "sonner";

const empty = { model_code: "", season: "", note: "" };

export default function ModelCardDialog({ open, onOpenChange, editing, onSaved }) {
  const [form, setForm] = useState(empty);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open) setForm(editing ? { model_code: editing.model_code, season: editing.season, note: editing.note } : empty);
  }, [open, editing]);

  const submit = async () => {
    if (!form.model_code.trim()) { toast.error("Model kodu zorunlu"); return; }
    setSaving(true);
    try {
      const r = editing ? await api.put(`/models/${editing.id}`, form) : await api.post("/models", form);
      toast.success(editing ? "Model güncellendi" : "Model oluşturuldu — şimdi renk ekleyin");
      onOpenChange(false);
      onSaved(r.data, !editing);
    } catch (e) { toast.error(e.response?.data?.detail || "Hata"); }
    finally { setSaving(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#FFFBF4] border-[#DCCFB8] text-[#2B2118] max-w-lg" data-testid="model-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl uppercase tracking-tight">{editing ? "Modeli Düzenle" : "Yeni Model Kodu"}</DialogTitle>
        </DialogHeader>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          <div>
            <Label className="text-xs text-[#6B5B4A]">Model Kodu *</Label>
            <Input data-testid="model-code-input" value={form.model_code} placeholder="Örn: 1157"
              onChange={(e) => setForm({ ...form, model_code: e.target.value })} className="mt-1 h-11 bg-[#EFE6D6] border-[#DCCFB8]" />
          </div>
          <div>
            <Label className="text-xs text-[#6B5B4A]">Sezon</Label>
            <Input data-testid="model-season-input" value={form.season} placeholder="Örn: Yaz 2026"
              onChange={(e) => setForm({ ...form, season: e.target.value })} className="mt-1 h-11 bg-[#EFE6D6] border-[#DCCFB8]" />
          </div>
          <div className="sm:col-span-2">
            <Label className="text-xs text-[#6B5B4A]">Not</Label>
            <Input data-testid="model-note-input" value={form.note}
              onChange={(e) => setForm({ ...form, note: e.target.value })} className="mt-1 h-11 bg-[#EFE6D6] border-[#DCCFB8]" />
          </div>
        </div>
        {editing && <p className="text-[11px] text-[#8C7B68]">Kod değişirse bu modelin tüm renkleri de yeni koda geçer.</p>}
        <DialogFooter>
          <Button onClick={submit} disabled={saving} data-testid="model-submit-btn"
            className="bg-[#D97706] hover:bg-[#B45309] text-white font-display uppercase tracking-wide h-11 px-6">
            {saving ? "Kaydediliyor..." : "Kaydet"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
